import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import {Order} from "@beeldit/ecommerce/orders/models/Order";
import useDownloadInvoice from "@beeldit/ecommerce/orders/actions/download-invoice/useDownloadInvoice";

function useDownloadInvoiceAction(): any {

  const onSuccess= () => {
    showSuccessMessage("successfull_action");
  };

  const downloadInvoice = useDownloadInvoice();

  const downloadInvoiceFunction = (order: Order) => downloadInvoice(order, onSuccess);

  return {
    downloadInvoiceFunction,
  };
}

export default useDownloadInvoiceAction;
